import type { SlotKey } from '#packages/apilib';

export interface EditorPointerAPI {}

export const EditorPointerApiKey: SlotKey<EditorPointerAPI> = {
  name: 'Editor Pointer API',
  public: true,
};
